import React from "react";
import { generatePath, useLocation, useNavigate, useParams } from "react-router-dom";
import { TREATMENT_PLAN_REPORT, TREATMENT_PLAN_REPORT_PREVIEW, TREATMENT_PLAN_START_SESSION } from "config/paths";
import ManageGoals from "../../components/ManageGoals";

const ClientTreatmentPlan = () => {
  const navigate = useNavigate();
  const { assessmentId, clientId, clientType } = useParams();

  const submitCallback = async (response) => {
    try {
      if (!response?.error) {
        navigate(
          generatePath(TREATMENT_PLAN_REPORT_PREVIEW, {
            assessmentId,
            clientId,
            clientType
          })
        );
      }
    } catch (err) {
      console.log("Error submitting step", err);
    }
  };

  const handleClickBack = () => {
    navigate(
      generatePath(TREATMENT_PLAN_REPORT, {
        assessmentId,
        clientId,
        clientType
      })
    );
  }

  return (
    <>
      <ManageGoals
        onSubmit={submitCallback}
        onNavigateBack={handleClickBack}
      />
    </>
  );
};

export default ClientTreatmentPlan;
